export default __webpack_public_path__ + "static/appnigma_full_logo-ffd3e9309c35ee9c5ff7947ff91141fe.webp";